const menuList = {
    staff: [
        {
            "iconName": "icon-jijiufaqi",
            "menuName": "急重症转诊-发起",
            "menuUrl": "/staff/faqi",
            roles: ['AID_ADM']
        },
        {
            "iconName": "icon-jijiujieshou",
            "menuName": "急重症转诊-接收",
            "menuUrl": "/staff/jieshou",
            roles: ['AID_ADM', 'AID_E_ADM']
        },
        {
            "iconName": "icon-jijiufaqi",
            "menuName": "远程会诊-发起",
            "menuUrl": "/staff/consult/faqi",
            roles: ['AID_ADM']
        },
        {
            "iconName": "icon-jijiujieshou",
            "menuName": "远程会诊-接收",
            "menuUrl": "/staff/consult/jieshou",
            roles: ['AID_ADM', 'AID_E_ADM']
        },
        {
            "iconName": "icon-jijiuyisheng",
            "menuName": "急救医生管理",
            "menuUrl": "/staff/doc",
            roles: ['AID_ADM']
        }, {
            "iconName": "icon-jijiuhushi",
            "menuName": "急救护士管理",
            "menuUrl": "/staff/hushi",
            roles: ['AID_ADM']
        }, {
            "iconName": "icon-siji",
            "menuName": "出车司机管理",
            "menuUrl": "/staff/siji",
            roles: ['AID_ADM']
        }, {
            "iconName": "icon-cheliang",
            "menuName": "车辆管理",
            "menuUrl": "/staff/cheliang",
            roles: ['AID_ADM']
        }],
    tj: [
        {
            "iconName": "el-icon-date",
            "menuName": "体检预约管理（日历）",
            "menuUrl": "/tj/rili"
        },
        {
            "iconName": "el-icon-menu",
            "menuName": "体检预约管理",
            "menuUrl": "/tj/index"
        },
        {
            "iconName": "el-icon-edit",
            "menuName": "体检机构统计",
            "menuUrl": "/tj/statistics"
        }
    ]
};
export default menuList
